import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import config from '../../config';
import FAQSection from '../../components/FAQSection';
import Breadcrumbs from '../../components/Breadcrumb';
import HeroBanner from '../../components/HeroBanner';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import iconFaq from '../../assets/images/siteImg/icon-faq.svg';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useChecklist } from '../../context/ChecklistContext';
import { getCurrentChecklistId } from '../../utils/checklistUtils';
import { useOverviewContext } from '../../context/OverviewContext';
import { getChatUrl, openChat } from '../../utils/menuUtils';
import bannerImage from '../../assets/images/banners/bannerImage_SchoolFAQs.png';

const SchoolStartFAQ: React.FC = () => {
const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "School Prep Checklist", path: "/school-prep-checklist" },
    { label: "Online School", path: "/k12-checklist-category/online-school" },
    { label: "School Start FAQs" }, 
];
// Get checklist data & currentChecklistId from ChecklistContext
const { checklistData } = useChecklist();
const currentChecklistId = getCurrentChecklistId(checklistData, "SCHOOL_START_FAQS");
const {userRoleVal, schoolType, schoolShortName, identityId} = useOverviewContext();
const attendenceKeyword = userRoleVal == "STUDENT" ? "may be" : "is";
const learning_material_link = ' <a href="/learning-materials/">our learning materials</a> ';
const chatUrl = identityId ? getChatUrl(identityId) : '';
const handleChatClick = () => {
    openChat(identityId ?? undefined);
};
const anchor_chat_link = (
    <a id="chat-link" onClick={handleChatClick} role="button" href="#" className="text-primary text-decoration-underline">Chat with them to get help!</a>
);

const schoolStartFAQs = [
    // {
    //   question: 'What do I do if I forget my login information?',
    //   answer: `You select your own username and password, so try to choose something easy for you to remember, but hard for others to guess. If you do forget, you can contact our customer care team to recover your information. ${anchor_chat_link}`,
    //   icon: iconFaq
    // },
    {
        question: 'What do I do if I forget my login information?',
        answer: (
          <>
            You select your own username and password, so try to choose something easy for you to remember, but hard for others to guess.
            If you do forget, you can contact our customer care team to recover your information. &nbsp; 
            <a
              id="faq-chat-link"
              onClick={handleChatClick}
              role="button"
              href="#"
              className="text-primary1 text-decoration-underline"
            >Chat with them to get help!</a>
          </>
        ),
        icon: iconFaq,
    },      
    {
        question: userRoleVal === 'STUDENT' ? "When will I get my schedule?" : "When will I get my student's schedule?",
        answer: "You'll hear from a placement coordinator soon after enrollment is complete. Depending on grade and course level, your school may need to complete a transcript analysis. For younger students, your teacher will be assigned just before the start of school, and you'll learn about your daily schedule directly from them.",
        icon: iconFaq
    },
    ...(schoolType !== "private" ? [
        {
            question: "What is the attendance policy?",
            answer: `Updating attendance daily ${attendenceKeyword} required at ${schoolShortName} . As your start date nears, teachers and staff will communicate the best ways to monitor and record online and offline school attendance.`,
            icon: iconFaq
        },
    ] : [] ),
    // {
    //     question: 'What learning materials will be sent? What if they don’t arrive before school starts?',
    //     answer: `Your school is aware of the timing of course placement and will accommodate a delay in receiving any textbooks, art, science, or math-related supplies. While waiting for learning materials, students can access online course content from a personal computer or a public computer, such as at a public library. Check ${learning_material_link} section for all the details! `,
    //     icon: iconFaq
    // },
    {
        question: 'What learning materials will be sent? What if they don’t arrive before school starts?',
        answer: (
            <>
              Your school is aware of the timing of course placement and will accommodate a delay in receiving any textbooks, art, science, or math-related supplies. While waiting for learning materials, students can access online course content from a personal computer or a public computer, such as at a public library. Check{' '}
              <a href="/learning-materials/" data-type="page" data-id="246">our learning materials</a> section for all the details!
            </>
          ),
        icon: iconFaq
    },
    {
        question: 'What happens on the first day of school?',
        answer: 'The first day of online school is often less dramatic than traveling to a busy school building, so be prepared for a softer start. First, log in to your Online School (OLS), check your email, and look for information from your teachers. You’ll have time to meet your teachers, make friends, and explore your courses. ',
        icon: iconFaq
    },
    ...(schoolType !== "private" ? [
        {
            question: userRoleVal === 'STUDENT' ? "How will I attend the classes?" : "How will my students attend the classes?",
            answer: "Students attend regularly scheduled, live online classes with their teachers. When students log in to their Online School (OLS) account, they'll see their scheduled classes and can link to the sessions when it's time for them to start.",
            icon: iconFaq
        },
        {
            question: userRoleVal === 'STUDENT' ? "What can I expect for quizzes?" : "What can my student expect for quizzes?",
            answer: "Most quizzes and tests are computer-graded, but teachers may occasionally ask students to use other tools to complete these types of assignments.",
            icon: iconFaq
        },
    ] : []),
    {
        question: 'What are the homework expectations?',
        answer: 'Students are expected to complete daily lessons and assignments in a timely manner according to the learning plan set by the teacher. Grading may vary by school and even by grade or course. Generally, any assessments (quizzes/tests) should be completed by the day they are assigned. Students often complete their daily work within their class time, but some additional homework time may be necessary.',
        icon: iconFaq
    },
    // Below FAQ only if userRole - LEARNING_COACH
    ...(userRoleVal === 'LEARNING_COACH' && schoolType !== "private" ? [
        {
            question: "If my child needs an IEP, when will I get to discuss their needs?",
            answer: "Once you have submitted an application for enrollment and we have a copy of your child's Individualized Education Plan (IEP), the Special Education Department will reach out to you directly to discuss how we can help your child succeed and talk about specific accommodations.",
            icon: iconFaq
        }
    ] : []
    ), 

  ];
return (
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
                <Header />
                <main id="main" role="main">
                <div className="main-content">
                    <div className="row">
                        <div className="col-12">
                            <Breadcrumbs items={breadcrumbItems} />
                        </div>
                    </div>

                    <HeroBanner
                        title="School Start FAQs "
                        subtitle="You asked; we answered! You may have to wait for more specific answers from your school, but here’s what to expect in the meantime. "
                        imageUrl={bannerImage}
                        altText="School Start FAQs "
                        customClass="bg-color-blue-t1-checklist common-banner-bg-white"
                    />

                
                    <div style={{ height: '20px' }} aria-hidden="true" className="wp-block-spacer" />

                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                            <FAQSection faqsData={schoolStartFAQs} />
                        </div>
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                        </div>
                    </div>

                    <div style={{ height: '20px' }} className="wp-block-spacer" aria-hidden="true" />
                   
                    {/* <MarkTopicAsReadButton checklistId="104" /> */}
                    {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} />}

                </div>
                </main>

            </div>
        </div>
        </div>
        <FooterMobile />
    </div>
);
};
export default SchoolStartFAQ;